module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-up.46d9b3a5.svg";